import { useLocation } from "wouter";
import { useGetSession } from "@/api/auth/queries";
import { Logo } from "@/components/ui/logo";
import NoSubscriptionImage from "@/assets/fallbacks/no-subscription.png";

/**
 * SubscriptionExpiredRoute component
 *
 * Shown instead of logging the user out when an API call returns a 402 (the account's
 * subscription has been cancelled/is inactive).
 */
export const SubscriptionExpiredRoute = () => {
  /* Stores */
  const [, setLocation] = useLocation();

  /* Queries */
  // Read only — never fetch here. GET would return a 401 as we didn't create a session.
  // Falls back to whatever's already cached from an earlier successful session fetch.
  const { data: session } = useGetSession({ enabled: false });

  /* Render */
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div className="bg-base-200 p-6 border border-base-content/10 rounded-2xl w-[calc(100%-2rem)] max-w-[602px] drop-shadow-2xl">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <Logo /> <h3 className="ml-1.5">Dragonfly</h3>
          </div>
          <div className="flex gap-4 items-center">
            {session?.user?.email && <p className="text-base-content/50">{session.user.email}</p>}
            <p className="text-secondary cursor-pointer hover:underline" onClick={() => setLocation("/auth/signout")}>
              Sign out
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4 mt-6">
          <img src={NoSubscriptionImage} alt="" className="h-24" />
          <h2 className="text-center">Your subscription is inactive</h2>
          <p className="text-center text-base-content/70">
            Please speak with your team admin if you would like your subscription to renew. If you did not expect to see this message, please reach out to{" "}
            <a className="underline" href="mailto:support@dragonflyai.co">
              support@dragonflyai.co
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};
